import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=6b833bc9"
import script from "./CopyModal.vue?vue&type=script&lang=js"
export * from "./CopyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports